import CartIcon from "../assets/cart-icon";
import HomeIcon from "../assets/home-icon";
import ListIcon from "../assets/list-icon";
import UserIcon from "../assets/user-icon";

export const bottomNavigationItems = [
  {
    title: "home",
    href: "/",
    icon: (color: string) => <HomeIcon color={color} />,
  },
  {
    title: "cart",
    href: "/cart",
    icon: (color: string) => <CartIcon color={color} />,
  },
  {
    title: "orders",
    href: "/orders",
    icon: (color: string) => <ListIcon color={color} />,
  },
  {
    title: "profile",
    href: "/profile",
    icon: (color: string) => <UserIcon color={color} />,
  },
];
